// extracted by mini-css-extract-plugin
export default {"choice":"styles_choice__2Ynff","icon":"styles_icon__grvaU","content":"styles_content__k647p"};